var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "app--main"
  }, [_c('section', {
    staticClass: "sub-visual"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap mb-24 mb-md-50 mb-lg-0"
  }, [_c('v-img', {
    staticClass: "tit-wrap__img",
    attrs: {
      "src": "/images/common/tit-img.png"
    }
  }), _c('h2', {
    staticClass: "tit tit--xl"
  }, [_vm._v(" Products ")])], 1)]), _c('v-img', {
    staticClass: "sub-visual__img",
    attrs: {
      "src": "/images/sub/product/sub-visual-product.jpg"
    }
  }), _c('sub-tab', {
    attrs: {
      "page": "제품안내"
    }
  })], 1), _c('section', {
    staticClass: "sub-section sub-section--product"
  }, [_c('v-container', [_c('div', {
    staticClass: "product pb-50 pb-md-74 pb-lg-100",
    attrs: {
      "id": "1"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "data-aos": "fade-right"
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "670",
      "src": "/images/sub/product/1.jpg"
    }
  })], 1)], 1), _c('v-col', {
    staticClass: "d-flex justify-end align-center",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', [_c('div', {
    staticClass: "tit-wrap tit-wrap--sm d-flex"
  }, [_c('h3', {
    staticClass: "tit w-auto line-height-135"
  }, [_vm._v(" 각종 소스류 ")]), _c('div', {
    staticClass: "ml-4"
  }, [_c('v-img', {
    attrs: {
      "max-width": "14",
      "src": "/images/common/tit-img.png"
    }
  })], 1)]), _c('p', {
    staticClass: "page-text page-text--lg line-height-17 grey--text"
  }, [_vm._v(" 모두에프엔티는 다양한 소스류 제품들을 보유하고 있습니다. 각종 면요리나 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 조리 음식에서 필수적인 소스부터, 고소하고 부드러운 맛이 매력인 마요네즈와 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 콘버터소스, 그리고 케찹, 핫소스, 우동소스,떡볶이소스, 토마토페이스트 등 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 각종 샐러드 소스/드레싱 등 요리에 매운맛, 달콤함, 고소함, 신맛을 더해 더욱 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 맛있게 만들어줍니다. 특히, 고객의 니즈에 맞춰 맞춤형 개발도 가능합니다. ")])])])], 1)], 1), _c('div', {
    staticClass: "product pb-50 pb-md-74 pb-lg-100",
    attrs: {
      "id": "2"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "12",
      "md": "6",
      "order": "2",
      "order-md": "1"
    }
  }, [_c('div', [_c('div', {
    staticClass: "tit-wrap tit-wrap--sm d-flex"
  }, [_c('h3', {
    staticClass: "tit w-auto line-height-135"
  }, [_vm._v(" 제과제빵류 ")]), _c('div', {
    staticClass: "ml-4"
  }, [_c('v-img', {
    attrs: {
      "max-width": "14",
      "src": "/images/common/tit-img.png"
    }
  })], 1)]), _c('div', {
    staticClass: "page-text page-text--lg line-height-17 grey--text"
  }, [_c('p', [_vm._v(" Pastry는 버터를 넣은 반죽에 계속해서 반죽과 버터를 쌓아서 레이어를 만들고, "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 모양을 만들어 낸 후 발효를 거쳐 오븐에서 구워서 만들어 다양한 제품이 될 수 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 있습니다. 부드러운 반죽 위에 다양한 토핑이나 필링을 올려 여러가지 디저트를 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 탄생시키기도 합니다. ")]), _c('p', [_vm._v(" 모두 에프엔티는 각종 페스츄리 생지,크로와상 생지 (미니 사이즈도 보유), "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 데니쉬 파이 생지, 애플 코로네 생지 , 뺑오 쇼콜라 생지, 베이글 등 공급 가능하"), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 며 앞으로 카페&베이커리 분야의 고객님들을 위해 사업에 힘쓰며 더욱 많은 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 서비스를 제공할 것입니다. ")])])])]), _c('v-col', {
    staticClass: "d-flex justify-end",
    attrs: {
      "cols": "12",
      "md": "6",
      "order": "1",
      "order-md": "2"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "data-aos": "fade-left"
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "670",
      "src": "/images/sub/product/2.jpg"
    }
  })], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "product pb-50 pb-md-74 pb-lg-100",
    attrs: {
      "id": "3"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "data-aos": "fade-right"
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "670",
      "src": "/images/sub/product/3.jpg"
    }
  })], 1)], 1), _c('v-col', {
    staticClass: "d-flex justify-end align-center",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', [_c('div', {
    staticClass: "tit-wrap tit-wrap--sm d-flex"
  }, [_c('h3', {
    staticClass: "tit w-auto line-height-135"
  }, [_vm._v(" 공산품식자재 ")]), _c('div', {
    staticClass: "ml-4"
  }, [_c('v-img', {
    attrs: {
      "max-width": "14",
      "src": "/images/common/tit-img.png"
    }
  })], 1)]), _c('div', {
    staticClass: "page-text page-text--lg line-height-17 grey--text"
  }, [_c('p', [_vm._v(" 식자재유통은 고객의 요구에 맞는 제품과 서비스를 제공하는 것이 중요합니다. "), _c('br'), _vm._v(" 조미료와 소스류는 요리에 꼭 필요한 맛과 향을 더해줍니다. ")]), _c('p', [_vm._v(" 주로 식당, 호텔, 프랜차이즈 외식업체 등에서 사용되는 식자재로 다양한 종류의 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 식재료, 가공식품, 조미료 등이 포함됩니다. 예를 들면, 밀가루, 쌀, 참기름, "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 들기름, 간장, 육류, 채소, 냉동해산물,식재료, 소스, 드레싱, 조미료, 차 등의 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 모두에프엔티의 식자재는 여러 업종에서 사용되며, 고객의 요구에 따라 맞춤형 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 제품을 공급하기도 합니다. ")])])])])], 1)], 1), _c('div', {
    staticClass: "product pb-50 mb-pd-74 pb-lg-100",
    attrs: {
      "id": "4"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "12",
      "md": "6",
      "order": "2",
      "order-md": "1"
    }
  }, [_c('div', [_c('div', {
    staticClass: "tit-wrap tit-wrap--sm d-flex"
  }, [_c('h3', {
    staticClass: "tit w-auto line-height-135"
  }, [_vm._v(" 유제품 ")]), _c('div', {
    staticClass: "ml-4"
  }, [_c('v-img', {
    attrs: {
      "max-width": "14",
      "src": "/images/common/tit-img.png"
    }
  })], 1)]), _c('div', {
    staticClass: "page-text page-text--lg line-height-17 grey--text"
  }, [_c('p', [_vm._v(" 유제품은 우유나 유당을 원료로 만들어진 식품으로, 치즈, 크림, 버터 등이 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 있습니다. 유제품은 단백질, 칼슘, 비타민 등 여러가지 영양소를 함유하고 있어 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 건강한 식습관에 필수적입니다. ")]), _c('p', [_vm._v(" 치즈는 고단백, 저지방의 식품으로, 다양한 요리에 이용되며 맛과 풍미를 더해줍니다. 버터는 구이나 베이킹 등 여러 조리에 이용되며 건강과 맛을 동시에 누릴 수 있는 좋은 선택입니다. ")]), _c('p', [_vm._v(" 모두 에프엔티는 넓은 선택 폭으로 고객의 제안을 적극적으로 이를 수용하고 반영하여 유연하게 대응 하려 노력 합니다. ")])])])]), _c('v-col', {
    staticClass: "d-flex justify-end",
    attrs: {
      "cols": "12",
      "md": "6",
      "order": "1",
      "order-md": "2"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "data-aos": "fade-left"
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "670",
      "src": "/images/sub/product/4.jpg"
    }
  })], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "product pb-50 pb-md-74 pb-lg-100",
    attrs: {
      "id": "5"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "data-aos": "fade-right"
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "670",
      "src": "/images/sub/product/5.jpg"
    }
  })], 1)], 1), _c('v-col', {
    staticClass: "d-flex justify-end align-center",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', [_c('div', {
    staticClass: "tit-wrap tit-wrap--sm d-flex"
  }, [_c('h3', {
    staticClass: "tit w-auto line-height-135"
  }, [_vm._v(" 면류 ")]), _c('div', {
    staticClass: "ml-4"
  }, [_c('v-img', {
    attrs: {
      "max-width": "14",
      "src": "/images/common/tit-img.png"
    }
  })], 1)]), _c('div', {
    staticClass: "page-text page-text--lg line-height-17 grey--text"
  }, [_c('p', [_vm._v(" 면류는 여러가지 종류 와 형태를 가지고 있습니다."), _c('br'), _vm._v(" 대표적인 면류로는 국수, 라면, 우동 등이 있어 각각 다양한 소스와 함께 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 조리하여 식사를 즐길 수 있습니다. 면류는 쉽고 빠르게 조리가 가능하여 바쁜 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 현대인들에게 매우 인기가 높으며, 또한 면류는 한국뿐만 아니라 전 세계에서도 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 많이 즐겨 사용되는 식자재 중 하나입니다. ")]), _c('p', [_vm._v(" 모두 에프엔티에서는 파스타 면, 스파게티 면, 페투치니 면 등 라면사리, "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 칼국수 사리, 쫄면 사리 등각각 사업장 특성에 맞게 공급 가능합니다. ")])])])])], 1)], 1), _c('div', {
    staticClass: "product pb-50 pb-md-74 pb-lg-100",
    attrs: {
      "id": "6"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "12",
      "md": "6",
      "order": "2",
      "order-md": "1"
    }
  }, [_c('div', [_c('div', {
    staticClass: "tit-wrap tit-wrap--sm d-flex"
  }, [_c('h3', {
    staticClass: "tit w-auto font-pretendard line-height-135"
  }, [_vm._v(" 냉동/냉장식품 ")]), _c('div', {
    staticClass: "ml-4"
  }, [_c('v-img', {
    attrs: {
      "max-width": "14",
      "src": "/images/common/tit-img.png"
    }
  })], 1)]), _c('div', {
    staticClass: "page-text page-text--lg line-height-17 grey--text"
  }, [_c('p', [_vm._v(" 모두에프엔티는 다양한 냉동/냉장식품을 제공하며, 신선하고 맛있는 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 식재료를 고객들에게 제공합니다. 냉장식품은 간편하게 조리할 수 있어 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 바쁜 현대인들에게 인기가 있습니다. 또한, 저온 보관 방식으로 유통기한을 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 연장하므로, 장기간 보관해도 신선한 맛과 영양소를 유지할 수 있습니다. ")]), _c('p', [_vm._v(" 빠르게 많은 양의 식자재를 소비하는 업장에 필요 할 수 있으며 냉동만두, "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 냉동완자,새우튀김, 냉동돈까스, 함박스테이크 등 이 외에도 많은 제품이 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 있습니다. ")])])])]), _c('v-col', {
    staticClass: "d-flex justify-end",
    attrs: {
      "cols": "12",
      "md": "6",
      "order": "1",
      "order-md": "2"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "data-aos": "fade-left"
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "670",
      "src": "/images/sub/product/6.jpg"
    }
  })], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "product pb-50 pb-md-74 pb-lg-100",
    attrs: {
      "id": "7"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "data-aos": "fade-right"
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "670",
      "src": "/images/sub/product/7.jpg"
    }
  })], 1)], 1), _c('v-col', {
    staticClass: "d-flex justify-end align-center",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', [_c('div', {
    staticClass: "tit-wrap tit-wrap--sm d-flex"
  }, [_c('h3', {
    staticClass: "tit w-auto line-height-135"
  }, [_vm._v(" 육가공류 ")]), _c('div', {
    staticClass: "ml-4"
  }, [_c('v-img', {
    attrs: {
      "max-width": "14",
      "src": "/images/common/tit-img.png"
    }
  })], 1)]), _c('div', {
    staticClass: "page-text page-text--lg line-height-17 grey--text"
  }, [_c('p', [_vm._v(" 육가공류는 육류를 다양한 방법으로 가공하여 만든 제품으로, 보관기간이 길고 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 각각 제품은 다른 가공 방법과 맛을 가지고 있습니다. 또한 건강한 식습관 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 추구에 맞춰 낮은 열량과 나쁜 지방을 줄인 제품도 많이 출시되고 있습니다. ")]), _c('p', [_vm._v(" 모두에프엔티에서도 소세지,햄,베이컨,소고기류,돼지고기류,닭고기류 등 여러 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 육가공품이 항시 준비되어 있습니다. ")])])])])], 1)], 1), _c('div', {
    attrs: {
      "id": "8"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "12",
      "md": "6",
      "order": "2",
      "order-md": "1"
    }
  }, [_c('div', [_c('div', {
    staticClass: "tit-wrap tit-wrap--sm d-flex"
  }, [_c('h3', {
    staticClass: "tit w-auto font-pretendard line-height-135"
  }, [_vm._v(" 야채/신선식품 ")]), _c('div', {
    staticClass: "ml-4"
  }, [_c('v-img', {
    attrs: {
      "max-width": "14",
      "src": "/images/common/tit-img.png"
    }
  })], 1)]), _c('div', {
    staticClass: "page-text page-text--lg line-height-17 grey--text"
  }, [_c('p', [_vm._v(" 야채 및 신선 식품은 건강에 좋은 영양소를 풍부하게 함유하고 있습니다 많은 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 조리 방법으로 맛을 내어 많은 사람들에게 항시 인기가 있습니다. 또한, 신선한 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 상태에서 구매해야 영양성분이 손실되지 않으므로, 신선도 유지에 노력이 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 필요합니다. ")]), _c('p', [_vm._v(" 모두에프엔티는 고품질의 야채 및 신선 식품을 직접 공수해 입찰 하며 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 고객들에게 제공하고 있습니다. ")])])])]), _c('v-col', {
    staticClass: "d-flex justify-end",
    attrs: {
      "cols": "12",
      "md": "6",
      "order": "1",
      "order-md": "2"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "data-aos": "fade-left"
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "670",
      "src": "/images/sub/product/8.jpg"
    }
  })], 1)], 1)], 1)], 1)])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }